import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { AgreementCell } from '../../common/datagrid';
import { AgNumberCellRenderer } from '../../common/datagrid/components/AgNumberCellRenderer';
import { InactivatePriceRow } from './inactivatePriceTypes';

const commonRowProps: Partial<ColDef<InactivatePriceRow>> = {
    sortable: true,
    resizable: true,
    floatingFilter: true,
    filter: 'agTextColumnFilter',
    floatingFilterComponentParams: {
        suppressFilterButton: true
    }
};

export const inactivatePriceTableInitialColumns = (() => {
    const initialColumns: ColDef<InactivatePriceRow>[] = [
        {
            field: 'productId',
            headerName: 'Product id',
            width: 100,

            cellRenderer: ({ data: row }: ICellRendererParams<InactivatePriceRow>) =>
                AgreementCell({
                    value: String(row?.productId),
                    agreementPriceIds: row?.agreementPriceIds ?? [],
                    priceType: 'in'
                })
        },
        {
            field: 'productName',
            headerName: 'Product name',
            width: 300
        },
        {
            field: 'netWeight',
            headerName: 'Net weight',
            width: 90,
            cellRenderer: AgNumberCellRenderer
        },
        {
            field: 'unit',
            headerName: 'Unit',
            width: 80
        },
        {
            field: 'country',
            headerName: 'Country',
            width: 82
        },
        {
            field: 'purchaser',
            headerName: 'Purchaser',
            width: 120
        },
        {
            field: 'stock',
            headerName: 'Stock',
            width: 80,
            cellRenderer: AgNumberCellRenderer
        }
    ];

    const colMap: { [key: string]: ColDef<InactivatePriceRow> } = {};
    for (const column of initialColumns) {
        if (column.field != null) {
            colMap[column.field] = {
                ...column,
                ...commonRowProps
            };
        }
    }

    return colMap;
})();
